import React from 'react';

import { useTranslation } from '../../../../hooks';
import { T } from '../../../../constants';
import "./style.scss";

interface CashbackClaimSuccessModalProps {
  onClose: () => void;
  rewardAmount: number;
  cashbackCurrencyCode: string;
}

export const CashbackClaimSuccessModal: React.FC<CashbackClaimSuccessModalProps> = ({
  onClose,
  rewardAmount,
  cashbackCurrencyCode
}) => {

  const t = useTranslation();
  return (
    <div className="ftn-succes-popup-wrapper">
      <div className="ftn-success-popup-container">
        <button
          type="button"
          onClick={onClose}
          className="success-popup-close-button"
        >
          <i className="icon-close success-close-button-icon" />
        </button>
        <div className="ftn-success-popup-content">
          <p className="ftn-success-popup-title">{t(T.CONGRATULATIONS)}</p>
          <div className="popup-coin-image-holder">
            <span className="ftn-success-popup-text">
              {t(T.YOU_HAVE_WON)}
            </span>
            <span className="ftn-success-popup-amount">
              {rewardAmount} {cashbackCurrencyCode}
            </span>
          </div>
          <button className="ftn-popup-btn" onClick={onClose}>
            <span className="main-popup-btn-text">{t(T.CONTINUE)}</span>
          </button>
        </div>
      </div>
    </div>
  );
};
